import { useEffect } from 'react'

import { LoadingTurbo } from 'atoms'
import { OpportunityType } from 'integration/resources/newOpportunities'
import { OPPORTUNITY_TYPE_ENUM } from 'integration/resources/opportunitiesV3'
import { RootStackScreenComponent } from 'navigation/types'

export const OrganizationOpportunityListRedirect: RootStackScreenComponent<
  'OrganizationOpportunityList'
> = ({ navigation }) => {
  useEffect(() => {
    navigation.replace('OpportunitiesList')
  }, [navigation])

  return <LoadingTurbo />
}

export const OrganizationOpportunityRedirect: RootStackScreenComponent<
  'OrganizationOpportunity'
> = ({ navigation, route }) => {
  useEffect(() => {
    navigation.replace('OpportunitiesDetails', {
      id: route.params.id,
      type: OPPORTUNITY_TYPE_ENUM.ODC
    })
  }, [navigation, route.params.id])

  return <LoadingTurbo />
}

export const OpportunityDetailsRedirect: RootStackScreenComponent<'OpportunityDetails'> = ({
  navigation,
  route
}) => {
  useEffect(() => {
    const routeType = route.params.type as OpportunityType | OPPORTUNITY_TYPE_ENUM | undefined

    const type =
      routeType === OpportunityType.ACTIVE_BASE || routeType === OPPORTUNITY_TYPE_ENUM.ACTIVE_BASE
        ? OPPORTUNITY_TYPE_ENUM.ACTIVE_BASE
        : OPPORTUNITY_TYPE_ENUM.ODC

    navigation.replace('OpportunitiesDetails', {
      id: route.params.id,
      type
    })
  }, [navigation, route.params.id, route.params.type])

  return <LoadingTurbo />
}

export const OpportunityScreenRedirect: RootStackScreenComponent<'Opportunity'> = ({
  navigation
}) => {
  useEffect(() => {
    navigation.replace('OpportunitiesList')
  }, [navigation])

  return <LoadingTurbo />
}

export const OpportunityFilterRedirect: RootStackScreenComponent<'OpportunityFilter'> = ({
  navigation
}) => {
  useEffect(() => {
    navigation.replace('OpportunitiesV3Filter')
  }, [navigation])

  return <LoadingTurbo />
}

export const OpportunityOrderByFilterRedirect: RootStackScreenComponent<
  'OpportunityOrderByFilter'
> = ({ navigation }) => {
  useEffect(() => {
    navigation.replace('OpportunitiesList')
  }, [navigation])

  return <LoadingTurbo />
}
